import {
  GET_DETAILED_BALANCE_REQUEST,
  GET_DETAILED_BALANCE_SUCCESS,
  GET_DETAILED_BALANCE_FAILURE
} from 'Store/constants';

const initialState = {
  data: {
    availableTopWinPoint: false,
    balance: 0,
    amountInfoList:
      [
        { amountType: 'MONEY', amount: 0 },
        { amountType: 'BILYONER_BONUS', amount: 0 }
      ]
  },
  isLoading: null,
  error: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_DETAILED_BALANCE_REQUEST:
      return { ...state, isLoading: true, error: null };

    case GET_DETAILED_BALANCE_SUCCESS:
      return { data: action.payload, isLoading: false, error: null };

    case GET_DETAILED_BALANCE_FAILURE:
      return { ...initialState, isLoading: false, error: action.payload };

    default:
      return state;
  }
};
